
import React, { createContext, useContext, useState, ReactElement, Dispatch } from "react";
import { headerMenuType, radioType, business, inputType, selectType, teamType, ProjectRoleType } from "./interfaces";

interface AppContextType {
    clients: any[],
    setClients: (clients: any) => void,
    roles: string[] | undefined,
    setRoles: Dispatch<React.SetStateAction<string[] | undefined>>,
    findRole: (title: string) => string | null,
    navbarData: headerMenuType[];
    setNavbarData: (data: headerMenuType[]) => void;
    toggleMenuItem: (id: number) => void,
    deActivePage: () => void,
    openLogout: boolean,
    setOpenLogout: (isOpen: boolean) => void,
    packageData: radioType[],
    setPackageData: (obj: any) => void,
    clientNameMain: radioType[],
    setClientNameMain: (value: any) => void,
    includeAddresses: radioType[],
    setIncludeAddresses: (obj: any) => void,
    businessType: business[],
    setBusinessType: (obj: any) => void,
    whichNounForm: radioType[],
    setWichNounForm: (obj: any) => void,
    webSitesData: inputType[],
    setWebSitesData: (obj: any) => void,
    phoneNumberData: selectType[],
    setPhoneNumberData: (obj: any) => void,
    socialMediaData: selectType[],
    setSocialMediaData: Dispatch<React.SetStateAction<selectType[]>>,
    formatPhoneNumber: (phoneNumber: string) => string,
    emailData: inputType[],
    setEmailData: (obj: any) => void,
    cNumberFormat: (phoneNumber: string) => string | undefined,
    teamData: teamType[],
    setTeamData: Dispatch<React.SetStateAction<teamType[]>>,
    projectType: ProjectRoleType[]
    setProjectType: Dispatch<React.SetStateAction<ProjectRoleType[]>>,
    openDelete: boolean,
    setOpenDelete: Dispatch<React.SetStateAction<boolean>>,
    concretClient: any,
    setConcretClient: Dispatch<React.SetStateAction<any>>,
    openPinCode: boolean,
    setOpenPinCode: Dispatch<React.SetStateAction<boolean>>,
    openPinForEdit: boolean,
    setOpenPinForEdit: Dispatch<React.SetStateAction<boolean>>,
    loading:boolean,
    setLoading:Dispatch<React.SetStateAction<boolean>>,
    mortgageLogoType: Array<radioType>,
    setMortgageLogoType: Dispatch<React.SetStateAction<Array<radioType>>>,
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: ReactElement }> = ({ children }) => {
    const [clients, setClients] = useState<Array<any>>([]);
    const [roles,setRoles] = useState<Array<string> | undefined>();
    const [navbarData, setNavbarData] = useState<headerMenuType[]>([
        {
            id: 1,
            title: "CLIENTS",
            active: false
        },
        {
            id: 2,
            title: "EMPLOYEES",
            active: false
        }
    ]);
    const [openLogout, setOpenLogout] = useState<boolean>(false);
    const [concretClient, setConcretClient] = useState<any>(null);
    const [openDelete, setOpenDelete] = useState<boolean>(false);
    const [packageData, setPackageData] = useState<radioType[]>([
        {
            id: 1,
            title: "Social",
            active: true
        },
        {
            id: 2,
            title: "Social Plus",
            active: false
        },
        {
            id: 3,
            title: "Social Pro",
            active: false
        },
        {
            id: 4,
            title: "Other",
            active: false
        },
    ]);
    const [clientNameMain, setClientNameMain] = useState<radioType[]>([
        {
            id: 1,
            title: "fullName",
            active: true
        },
        {
            id: 2,
            title: "companyName",
            active: false
        }
    ]);
    const [includeAddresses, setIncludeAddresses] = useState<radioType[]>([
        {
            id: 1,
            title: "Yes",
            active: true
        },
        {
            id: 2,
            title: "No",
            active: false
        },
    ]);
    const [businessType, setBusinessType] = useState<business[]>([
        {
            id: 1,
            title: "Real Estate",
            active: true,
            terms:[
                {
                    id: 11,
                    title: "Associate Broker",
                    active: true
                },
                {
                    id: 12,
                    title: "Broker",
                    active: false
                },
                {
                    id: 13,
                    title: "Realtor",
                    active: false
                },
                {
                    id: 14,
                    title: "Real Estate Agent",
                    active: false
                },
                {
                    id: 15,
                    title: "Other",
                    active: false
                }
            ]
        },
        {
            id: 2,
            title: "Mortgage",
            active: false,
            terms:[
                {
                    id: 21,
                    title: "Loan Officer",
                    active: true
                },
                {
                    id: 22,
                    title: "Mortgage Broker",
                    active: false
                },
                {
                    id: 23,
                    title: "Mortgage Advisor",
                    active: false
                },
                {
                    id: 24,
                    title: "Other",
                    active: false
                }
            ]
        },
        {
            id: 3,
            title: "Investment",
            active: false,
            terms:[
                {
                    id: 31,
                    title: "RE Investor",
                    active: true
                },
                {
                    id: 32,
                    title: "RE Wholesaler",
                    active: false
                },
                {
                    id: 33,
                    title: "RE Investment Company",
                    active: false
                },
                {
                    id: 34,
                    title: "Other",
                    active: false
                }
            ]
        },
        {
            id: 4,
            title: "Insurance",
            active: false,
            categories: [
                {
                    id: 41,
                    title: "Life Insurance",
                    active: true
                },
                {
                    id: 42,
                    title: "Health Insurance",
                    active: false
                },
                {
                    id: 43,
                    title: "Medicare Insurance",
                    active: false
                },
                {
                    id: 44,
                    title: "Home/Car Insurance",
                    active: false
                },
                {
                    id: 45,
                    title: "Final Expense",
                    active: false
                }
            ],
            terms:[
                {
                    id: 41,
                    title: "Insurance Agent",
                    active: true
                },
                {
                    id: 42,
                    title: "Insurance Broker",
                    active: false
                },
                {
                    id: 43,
                    title: "Insurance Advisor",
                    active: false
                },
                {
                    id: 44,
                    title: "Other",
                    active: false
                }
            ]
        },
        {
            id: 5,
            title: "Other",
            active: false,
            terms:[
                {
                    id: 51,
                    title: "Other",
                    active: false
                }
            ]
        },
    ]);
    const [mortgageLogoType, setMortgageLogoType] = useState<radioType[]>([
        {
            id: 1,
            title: "Equal Housing Opportunity",
            active: false
        },
        {
            id: 2,
            title: "Equal Housing Lender",
            active: false
        },
        {
            id: 3,
            title: 'None',
            active: false
        }
    ]);
    const [whichNounForm, setWichNounForm] = useState<radioType[]>([
        {
            id: 1,
            title: "Singular",
            active: false
        },
        {
            id: 2,
            title: "Plural",
            active: false
        }
    ]);
    const [webSitesData, setWebSitesData] = useState<inputType[]>([
        {
            id:1,
            text: ""
        }
    ]);
    const [phoneNumberData, setPhoneNumberData] = useState<selectType[]>([
        {
            id: 1,
            text: "",
            isOpen:false,
            category: [
                {
                    id: 11,
                    title: "Office",
                    active: false
                },
                {
                    id: 12,
                    title: "Cell",
                    active: true
                },
                {
                    id: 13,
                    title: "Business",
                    active: false
                }
            ]
        }
    ]);
    const [socialMediaData, setSocialMediaData] = useState<selectType[]>([
        {
            id:1,
            text: "",
            isOpen:false,
            category: [
                {
                    id: 11,
                    title: "Facebook",
                    active: true
                },
                {
                    id: 12,
                    title: "Instagram",
                    active: false
                },
                {
                    id: 13,
                    title: "LinkedIn",
                    active: false
                },
                {
                    id: 14,
                    title: "X",
                    active: false
                },
                {
                    id: 15,
                    title: "YouTube",
                    active: false
                },
                {
                    id: 16,
                    title: "TikTok",
                    active: false
                },
                {
                    id: 19,
                    title: "Messenger",
                    active: false
                },
                {
                    id: 17,
                    title: "Pinterest",
                    active: false
                },
                {
                    id: 18,
                    title: "Other",
                    active: false
                },
            ]
        }
    ]);
    const [emailData, setEmailData] = useState<inputType[]>([
        {
            id: 1,
            text: ""
        }
    ]);

    const [teamData, setTeamData] = useState<teamType[]>([
        {
            id: 1,
            title: "MANAGEMENT",
            text: "Management",
            active: false
        },
        {
            id: 2,
            title: "CUSTOMER_SUPPORT",
            text: "Customer Support",
            active: false
        },
        {
            id: 3,
            title: "QC",
            text: "QC",
            active: false
        },
        {
            id: 4,
            title: "LEAD_GENERATION",
            text: "Lead Generation",
            active: false
        },
        {
            id: 5,
            title: "MARKETING",
            text: "Marketing",
            active: false
        },
        {
            id: 6,
            title: "ACCOUNTANT",
            text: "Accountant",
            active: false
        },
        {
            id: 7,
            title: "SALES",
            text: "Sales",
            active: false
        },
        {
            id: 8,
            title: "IT",
            text: "IT",
            active: false
        },
        {
            id: 9,
            title: "BILLING",
            text: "Billing",
            active: false
        },
        {
            id: 10,
            title: "GRAPHIC_DESIGN",
            text: "Graphic Design",
            active: false
        }
    ]);
    const [projectType, setProjectType] = useState<ProjectRoleType[]>([
        {
            id:1,
            isOpenProjects:false,
            isOpenRoles: false,
            projects:[
                {
                    id: 1,
                    title: "Project X",
                    text: "PX",
                    active: false
                },
                {
                    id: 2,
                    title: "Billing Sheet",
                    text: "BS",
                    active: false
                },
                {
                    id: 3,
                    title: "Flyer Maker",
                    text: "FM",
                    active: false
                },
                {
                    id: 4,
                    title: "Video Maker",
                    text: "VM",
                    active: false
                },
                {
                    id: 5,
                    title: "Cover Maker",
                    text: "CM",
                    active: false
                },
                {
                    id: 6,
                    title: "QR Code",
                    text: "QR",
                    active: false
                },
                {
                    id: 7,
                    title: "Linkedin",
                    text: "IN",
                    active: false
                },
                {
                    id: 8,
                    title: "Meta Post",
                    text: "MP",
                    active: false
                },
                {
                    id: 9,
                    title: "Auto Posting",
                    text: "AP",
                    active: false
                },
                {
                    id: 10,
                    title: "Ad Campaign",
                    text: "AC",
                    active: false
                },
                {
                    id: 11,
                    title: "Jotform",
                    text: "JF",
                    active: false
                },
                {
                    id: 12,
                    title: "Lead Center",
                    text: "LC",
                    active: false
                },
                {
                    id: 13,
                    title: "Sales Sheet",
                    text: "SS",
                    active: false
                },
                {
                    id: 14,
                    title: "Complaints Sheet",
                    text: "CS",
                    active: false
                },
                {
                    id: 15,
                    title: "Timekeeper",
                    text: "TK",
                    active: false
                },
                {
                    id: 16,
                    title: "Generic Forms",
                    text: "GF",
                    active: false
                },
                {
                    id: 17,
                    title: "SSL Tracker",
                    text: "ST",
                    active: false
                },
                {
                    id: 18,
                    title: "Lead Generation Center",
                    text: "LCT",
                    active: false
                },

                {
                    id: 19,
                    title: "Voice Campaign",
                    text: "VC",
                    active: false
                },
                {
                    id: 20,
                    title: "Commission Hub",
                    text: "CH",
                    active: false
                },
                {
                    id: 21,
                    title: "Article Generation",
                    text: "AG",
                    active: false
                }
            ],
            roles:[
                {
                    id: 1,
                    title: "Admin",
                    active: false
                },
                {
                    id: 2,
                    title: "Moderator",
                    active: false
                },
                {
                    id: 3,
                    title: "User",
                    active: false
                },
            ]
        }
    ]);

    const [openPinCode, setOpenPinCode] = useState<boolean>(false);
    const [openPinForEdit, setOpenPinForEdit] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const toggleMenuItem = (id: number) => {
        setNavbarData(prevMenu => prevMenu.map(item => {
            if (item.id === id) {
                return { ...item, active: true };
            }
            else {
                return { ...item, active: false };
            }
        }));
    }

    const deActivePage = () => {
        setNavbarData(prevMenu => prevMenu.map(item => { return { ...item, active: false } }));
    }

    const findRole = (title: string): string | null => {
        const roleObject: any = roles?.find((role: any) => role.project === title);
        if (roleObject) {
            return roleObject.role;
        }
        else return null;
    }

    const formatPhoneNumber = (phoneNumber: string): string => {
        let numericPhoneNumber = '';
        for (let i = 0; i < phoneNumber.length; i++) {
            if (phoneNumber[i] >= '0' && phoneNumber[i] <= '9') {
                numericPhoneNumber += phoneNumber[i];
            }
        }

        if (numericPhoneNumber.length < 10) {
            return phoneNumber;
        }

        const areaCode = numericPhoneNumber.substring(0, 3);
        const prefix = numericPhoneNumber.substring(3, 6);
        const lineNum = numericPhoneNumber.substring(6, 10);
        return `(${areaCode}) ${prefix}-${lineNum}`;
    };

    const cNumberFormat = (cardValue: string): string | undefined => {
        let numericCardValue = '';
        for (let i = 0; i < cardValue.length; i++) {
            if (cardValue[i] >= '0' && cardValue[i] <= '9') {
                numericCardValue += cardValue[i];
            }
        }

        if (numericCardValue.startsWith('5') || numericCardValue.startsWith('4') || numericCardValue.startsWith('6')) {
            // numericCardValue.length = 16;
            const firstFourDigit = numericCardValue.substring(0, 4);
            const secondFourDigit = numericCardValue.substring(4, 8);
            const thirdFourDigit = numericCardValue.substring(8, 12);
            const forthFourDigit = numericCardValue.substring(12, 16);
            return `${firstFourDigit}-${secondFourDigit}-${thirdFourDigit}-${forthFourDigit}`;
        }
        else if (numericCardValue.startsWith('3')) {
            const americanFirstFourDigit = numericCardValue.substring(0, 4);
            const americanSecondFourDigit = numericCardValue.substring(4, 10);
            const americanThirdFourDigit = numericCardValue.substring(10, 15);
            return `${americanFirstFourDigit}-${americanSecondFourDigit}-${americanThirdFourDigit}`;
        }
    }

    return (
        <AppContext.Provider value = {{
            findRole,
            toggleMenuItem,
            deActivePage,
            formatPhoneNumber,
            cNumberFormat,
            clients, setClients,
            roles, setRoles,
            navbarData, setNavbarData,
            openLogout, setOpenLogout,
            packageData, setPackageData,
            clientNameMain, setClientNameMain,
            includeAddresses, setIncludeAddresses,
            businessType, setBusinessType,
            mortgageLogoType, setMortgageLogoType,
            whichNounForm, setWichNounForm,
            webSitesData, setWebSitesData,
            phoneNumberData, setPhoneNumberData,
            socialMediaData, setSocialMediaData,
            emailData, setEmailData,
            teamData, setTeamData,
            projectType, setProjectType,
            openDelete, setOpenDelete,
            concretClient, setConcretClient,
            openPinCode, setOpenPinCode,
            openPinForEdit, setOpenPinForEdit,
            loading, setLoading
        }}>
            { children }
        </AppContext.Provider>
    );
}

export const useGlobalContext = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error("useAppContext must be used within an AppProvider");
    }
    return context;
}
